<style lang="less" scoped>
.layout{position: absolute; background: rgba(33,55,69,.7);-webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2)); filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));overflow: hidden;border-radius: 10px; bottom: 12px;height: 500px; top: 50%;left: 50%;transform: translate(-50%, -50%);}
.title{width: 663px; height: 42px;margin: 0px;line-height: 35px;text-align: right;padding: 0 20px;color: #fff; font-size: 16px;display: flex;justify-content: space-between;}
.out{position: absolute;top: 11px;left: 670px;color: #fff;z-index: 99;cursor: pointer;}
</style>

<template>
  <div class="layout" v-drag v-if="flag">
    <p class="title">
      <a href="#" id="popup-closer" class="ol-popup-closer" ></a>
    </p>
    <span class="out" @click="closePul(false)">X</span>
    <FileManage :params="param"></FileManage>
  </div>
</template>

<script>
/** 组件 - 文件管理 */
import FileManage from '@/plugins/app/com/fileManage/FileManage.vue'
export default
{
  components: {FileManage},
  data()
  {
    return {
      flag: false,
      param:
      {
        major: 1,
        minor: 1,
        rootfile: 'uploadfile/资料库/'
      }
    }
  },
  methods:
  {
    //关闭插件
    closePul(show)
    {
      this.flag = show
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Database.vue